import React, { ReactNode } from "react";

type Props = {
    title: string;
    lede?: string;
    right?: ReactNode;
};

export const PageHeader: React.FC<Props> = ({ title, lede, right }) => (
    <div className="page-header">
        <div>
            <h1>{title}</h1>
            {lede !== undefined && lede !== "" ? <div className="lede">{lede}</div> : null}
        </div>
        {right !== undefined ? <div className="page-header__right">{right}</div> : null}
    </div>
);
